import StringsEn from "./Strings-en"
import StringsZh from "./Strings-zh"

export let strings: {[langCode: string]: {[key: string]: string}} = {
    "en": StringsEn,
    "zh": StringsZh
}